<template>
	<div class="settlement_account">
		<div class="card">
			<h3 class="title">
				<img :src="iconExchangeDetailTitle" alt="" />{{
					$t('merchant.settlement.title')
				}}
			</h3>
		</div>
		<div class="card mb_0">
			<div v-if="!isMobile" class="mt_20">
				<div>
					<table class="table_type type01 mb_40">
						<colgroup>
							<col style="width: 170px" />
						</colgroup>
						<thead>
							<tr>
								<th>{{ $t('merchant.settlement.date') }}</th>
								<th>{{ $t('merchant.settlement.asset_name') }}</th>
								<th>{{ $t('merchant.settlement.account') }}</th>
								<th>{{ $t('merchant.settlement.disconnect') }}</th>
							</tr>
						</thead>
						<tbody v-if="settlementAccounts.length > 0">
							<tr v-for="item in settlementAccounts" :key="item.seq">
								<td>
									{{ $dayjs(item.regdate).format('YYYY.MM.DD') }}
								</td>
								<td>{{ item.asset_title }}</td>
								<td>{{ item.account_number }}</td>
								<td @click="deleteHandler(item.seq)" class="link_off_box">
									<span class="link_off"></span>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td colspan="4">
									{{ $t('merchant.settlement.no_content') }}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div v-if="isMobile">
				<div v-if="settlementAccounts.length > 0" class="mb_16">
					<div
						v-for="item in settlementAccounts"
						:key="item.seq"
						class="list_content_all card"
					>
						<div class="list_content">
							<div>
								<p>{{ $t('merchant.settlement.date') }}</p>
								<p>
									{{ $dayjs(item.regdate).format('YYYY.MM.DD') }}
								</p>
							</div>
							<div>
								<p>{{ $t('merchant.settlement.asset_name') }}</p>
								<p class="">{{ item.asset_title }}</p>
							</div>
							<div>
								<p>{{ $t('merchant.settlement.account') }}</p>
								<p class="">{{ item.account_number }}</p>
							</div>
						</div>
						<div class="">
							<button class="w100" @click="onDisconnect(item)">
								<span class="link_off mr_5"></span>
								{{ $t('merchant.settlement.set_disconnect') }}
							</button>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="connect_none tac pt_30 pb_40">
						<span class="ERRORGRAY mb_4"></span>
						<div class="fc_gray2">
							{{ $t('merchant.settlement.no_content') }}
						</div>
					</div>
				</div>
			</div>
			<div class="tac">
				<button
					:class="['button_bg_blue', isMobile ? 'w100' : '']"
					@click="settlementAccountModal = true"
				>
					{{ $t('merchant.settlement.connect') }}
				</button>
			</div>
		</div>
	</div>
	<ModalView
		add-class="merchant register tal"
		v-if="settlementAccountModal && !isMobile"
		@closeModal="settlementAccountModal = false"
	>
		<SettlementAccountRegister
			@closeModal="settlementAccountModal = false"
			@successRegist="successRegist"
		></SettlementAccountRegister
	></ModalView>
	<ModalViewM
		add-class="merchant register"
		v-if="settlementAccountModal && isMobile"
		@closeModal="settlementAccountModal = false"
	>
		<template #title>
			<h3 class="modal_title_m">
				{{ $t('merchant.settlement.title1') }}
			</h3>
		</template>
		<SettlementAccountRegister
			@closeModal="settlementAccountModal = false"
			@successRegist="successRegist"
		></SettlementAccountRegister
	></ModalViewM>

	<ModalViewM
		v-if="disconnectPage && isMobile"
		@closeModal="disconnectPage = false"
	>
		<template #title>
			<h3 class="modal_title_m">
				{{ $t('merchant.settlement.title2') }}
			</h3>
		</template>
		<SettlementAccountDisconnect
			@successDisconnect="successDisconnect"
			:disconnect-info="disConnectInfo"
		></SettlementAccountDisconnect>
	</ModalViewM>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'success'" class="button_area">
			<button class="button_bg_blue" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'confirm'" class="button_area">
			<button class="button_primary" @click="messageModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button class="button_bg_blue" @click="deleteSettlementAccount">
				{{ $t('merchant.settlement.disconnect') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import ModalView from '@/components/Layout/ModalView';
import ModalViewM from '@/components/Layout/ModalView.m';
import ModalMessage from '@/components/Layout/ModalMessage';
import SettlementAccountDisconnect from '@/components/Merchant/Settlement/SettlementAccountDisconnect';
import SettlementAccountRegister from '@/components/Merchant/Settlement/SettlementAccountRegister';
import { deleteMerchantAccount, fetchMerchantAccountList } from '@/api/pg';
import iconExchangeDetailTitle from '@/assets/images/v2/icon/icon-exchange-detail-title.svg';
import { commonError } from '@/common/dialog';
export default {
	name: 'SettlementAccount',
	components: {
		ModalView,
		ModalViewM,
		ModalMessage,
		SettlementAccountRegister,
		SettlementAccountDisconnect,
	},
	data() {
		return {
			settlementAccounts: [],
			curPage: 1,
			listCount: 10,
			settlementAccountModal: false,
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			messageModalMode: '',
			deleteAccountSeq: null,
			iconExchangeDetailTitle,
			isMobile: false,
			disconnectPage: false,
		};
	},
	created() {
		this.init();
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		init() {
			this.loadSettlementAccountList();
		},
		async loadSettlementAccountList() {
			const { data } = await fetchMerchantAccountList(
				this.$route.params.merchant_seq,
			).catch(commonError);
			this.settlementAccounts = data;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadSettlementAccountList();
		},
		successRegist() {
			this.loadSettlementAccountList();
			this.settlementAccountModal = false;
			this.modalStatusMessage = this.$t('modal.message.settlement_connect');
			this.modalIcon = 'success';
			this.messageModalMode = 'success';
			this.messageModal = true;
		},
		deleteHandler(seq) {
			this.deleteAccountSeq = seq;
			this.modalStatusMessage = this.$t('modal.message.settlement_disconnect');
			this.modalIcon = 'information';
			this.messageModalMode = 'confirm';
			this.messageModal = true;
		},
		onDisconnect(accountInfo) {
			this.disConnectInfo = accountInfo;
			this.disconnectPage = true;
		},
		successDisconnect() {
			this.loadSettlementAccountList();
			this.disconnectPage = false;
			this.modalStatusMessage = this.$t('modal.message.settlement_disconnect2');
			this.modalIcon = 'success';
			this.messageModalMode = 'success';
			this.messageModal = true;
		},
		async deleteSettlementAccount() {
			const params = {
				merchant_seq: this.$route.params.merchant_seq,
				merchant_account_seq: this.deleteAccountSeq,
			};
			await deleteMerchantAccount(params)
				.then(() => {
					this.loadSettlementAccountList();
					this.modalStatusMessage = this.$t(
						'modal.message.settlement_disconnect2',
					);
					this.modalIcon = 'success';
					this.messageModalMode = 'success';
					this.messageModal = true;
				})
				.catch(commonError);
		},
		checkMobile() {
			this.isMobile = window.innerWidth <= 768;
		},
	},
};
</script>
